export const accountMap = {
  id: 'accountMap',
  name: _TL_('Account map'),
  route: 'AccountMap',
};
